import React, { Component } from 'react'
import jwt_decode from 'jwt-decode'

class Auth extends Component {
  constructor() {
    super();

    this._logoutCallback = null;
    this._loginCallback = null;
  }

  storeToken(tokens) {
    localStorage.token = tokens.token;
    localStorage.currentFBOId = tokens.fboId;
    localStorage.userId = tokens.userId;

    if (this._loginCallback !== null) {
      this._loginCallback();
    }
  }

  getCurrentUser() {
    return jwt_decode(localStorage.token);
  }

  getToken() {
    return localStorage.token;
  }

  getBearerToken() {
    return `Bearer ${localStorage.token}`;
  }

  loggedIn() {
    return !!localStorage.token;
  }

  hasFbo() {
    return localStorage.currentFBOId !== 'null';
  }

  logout() {
    delete localStorage.token;
    delete localStorage.currentFBOId;
    if (this._logoutCallback !== null) {
      this._logoutCallback();
    }else{
      window.location.reload();
    }
  }

  expired() {
    if (this.loggedIn()) {
      var token = jwt_decode(localStorage.token);
      var utcSeconds = token.exp;
      // The 0 sets the date to the epoch
      var expireDate = new Date(0);
      expireDate.setUTCSeconds(utcSeconds);

      return (expireDate < new Date());
    } else {
      return true;
    }
  }

  logoutCallback(callback) {
    this._logoutCallback = callback;
  }

  loginCallback(callback) {
    this._loginCallback = callback;
  }
}

export default new Auth()



// WEBPACK FOOTER //
// ./src/Containers/Authentication/Auth.js